export const APP_LOCALES = ['en', 'ptBR'] as const
export type AppLocale = (typeof APP_LOCALES)[number]

/** vue-i18n uses internal locale codes (e.g. `ptBR`); `Intl` requires BCP 47 (`pt-BR`). */
export function intlLocaleFromAppLocale(locale: string): string {
  const trimmed = locale.trim()
  if (!trimmed) {
    return 'en'
  }
  if (trimmed === 'ptBR') {
    return 'pt-BR'
  }
  const underscored = trimmed.replace(/_/g, '-')
  if (/^[a-z]{2}-[a-z0-9]+$/i.test(underscored)) {
    return underscored
  }
  // e.g. enUS → en-US if ever used
  if (/^[a-z]{2}[A-Z][a-zA-Z]+$/.test(trimmed)) {
    return `${trimmed.slice(0, 2)}-${trimmed.slice(2)}`
  }
  return trimmed
}

/** Nuxt landing-page i18n codes (`@nuxtjs/i18n`). */
export type LandingPageLocale = 'en' | 'pt'

export function landingPageLocaleToAppLocale(landingLocale: string): AppLocale {
  return landingLocale === 'pt' ? 'ptBR' : 'en'
}

export function appLocaleToLandingPageLocale(locale: AppLocale): LandingPageLocale {
  return locale === 'ptBR' ? 'pt' : 'en'
}

/** Parse `?locale=` from landing → app handoff or direct app links. */
export function parseAppLocaleParam(value: string | null | undefined): AppLocale | null {
  if (value === 'en' || value === 'ptBR') {
    return value
  }
  if (value === 'pt') {
    return 'ptBR'
  }
  return null
}
